<button
  type="button"
  (click)="decrement()"
  [disabled]="control.disabled || control.value <= min"
  [tabindex]="control.disabled || control.value <= min ? -1 : 0"
  attr.aria-label="{{ 'itemCounter.removeOne' | cxTranslate }}"
>
  -
</button>
<input
  #qty
  type="number"
  [min]="min"
  [max]="999" 
  [maxlength]="3"
  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
  [step]="step"
  [readonly]="readonly"
  [tabindex]="readonly ? -1 : 0"
  [formControl]="control"
  attr.aria-label="{{ 'itemCounter.quantity' | cxTranslate }}"
/>

<button
  type="button"
  (click)="increment()"
  [disabled]="disablePlus || control.disabled || control.value >= max"
  tabindex="0"
  attr.aria-label="{{ 'itemCounter.addOneMore' | cxTranslate }}"
>
  + {{max}}
</button>